import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import useCurrentOrganization from 'hooks/useCurrentOrganization';
import useGlobalStore from 'hooks/useGlobalStore';
import usePageRoutes from 'hooks/usePageRoutes';

const UserOrganizationGuard = ({ onPassed }: { onPassed?: (passed: boolean) => void }) => {
    const navigate = useNavigate();
    const { onboardingOrganizationCreationPage } = usePageRoutes();
    const { fetchCurrentOrganization, isLoading } = useCurrentOrganization();

    const { getValue } = useGlobalStore({
        namespace: 'useCurrentOrganization'
    });

    const currentOrganization = getValue('currentOrganization');

    useEffect(() => {
        if (!currentOrganization && !isLoading) {
            fetchCurrentOrganization();
        }
    }, [currentOrganization, fetchCurrentOrganization, isLoading]);

    if (!currentOrganization) {
        if (isLoading) {
            return null;
        }

        navigate(onboardingOrganizationCreationPage);
    }

    if (currentOrganization) {
        onPassed?.(true);

        return <Outlet />;
    }

    return null;
};

export default UserOrganizationGuard;
